export default function PHP_fgetcsv() {
  return (
    <div>
      <h1>PHP_fgetcsv</h1>
    </div>
  );
}
